import { KoreanLanguagePath, KoreanLanguagePathTitle } from 'Constants/Navigation'
import { KoreanSchoolContentBodyType, KoreanSchoolContentQueryType } from 'Entities/koreanSchoolContent'
import { useLocation } from 'react-router-dom'

export type KoreanLanguageRouteConfig = {
  subPath: KoreanLanguagePath
  /** GET /api/org/korean-school-contents?type= */
  schoolContentQueryType: KoreanSchoolContentQueryType
  /** POST/PATCH body field `type` */
  schoolContentBodyType: KoreanSchoolContentBodyType
  /** Section list + editor materials (all sub-routes) */
  contentAddTitle: string
  /** Statistics only: primary action for regional schools */
  schoolSectionAddTitle?: string
  /** Statistics only: primary action for universities list */
  universitySectionAddTitle?: string
  /** Exemplary only: primary action for leading schools */
  exemplarySchoolSectionAddTitle?: string
}

export const useKoreanLanguageConfig = (): KoreanLanguageRouteConfig => {
  const location = useLocation()

  if (location.pathname.includes(KoreanLanguagePath.statistics)) {
    return {
      subPath: KoreanLanguagePath.statistics,
      schoolContentQueryType: KoreanSchoolContentQueryType.STATISTICS,
      schoolContentBodyType: 'STATISTICS',
      schoolSectionAddTitle: 'Добавить школу',
      universitySectionAddTitle: 'Добавить университет',
      contentAddTitle: `Добавить материал: ${KoreanLanguagePathTitle.statistics}`,
    }
  }

  if (location.pathname.includes(KoreanLanguagePath.support)) {
    return {
      subPath: KoreanLanguagePath.support,
      schoolContentQueryType: KoreanSchoolContentQueryType.SUPPORT,
      schoolContentBodyType: 'SUPPORT',
      contentAddTitle: `Добавить материал: ${KoreanLanguagePathTitle.support}`,
    }
  }

  if (location.pathname.includes(KoreanLanguagePath.activity)) {
    return {
      subPath: KoreanLanguagePath.activity,
      schoolContentQueryType: KoreanSchoolContentQueryType.ACTIVITY,
      schoolContentBodyType: 'ACTIVITY',
      contentAddTitle: `Добавить материал: ${KoreanLanguagePathTitle.activity}`,
    }
  }

  if (location.pathname.includes(KoreanLanguagePath.exemplary)) {
    return {
      subPath: KoreanLanguagePath.exemplary,
      schoolContentQueryType: KoreanSchoolContentQueryType.SAMPLE,
      schoolContentBodyType: 'SAMPLE',
      exemplarySchoolSectionAddTitle: 'Добавить школу',
      contentAddTitle: `Добавить материал: ${KoreanLanguagePathTitle.exemplary}`,
    }
  }

  return {
    subPath: KoreanLanguagePath.statistics,
    schoolContentQueryType: KoreanSchoolContentQueryType.STATISTICS,
    schoolContentBodyType: 'STATISTICS',
    schoolSectionAddTitle: 'Добавить школу',
    universitySectionAddTitle: 'Добавить университет',
    contentAddTitle: `Добавить материал: ${KoreanLanguagePathTitle.statistics}`,
  }
}
